import { useState, useEffect } from 'react'


// TODO add service workers - added on 3/23/20 by pavelivanov
const loadedScripts = {}

const loadScript = (src, async = true) => {
  if (loadedScripts[src]) {
    return Promise.resolve()
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script')

    script.async = async
    script.type = 'text/javascript'
    script.src = src

    script.onerror = (err) => {
      console.error(`Script "${src}" load error: ${err}`)

      if (script.parentNode) {
        script.parentNode.removeChild(script)
      }

      reject(err)
    }

    script.onload = () => {
      console.log(`Script "${src}" loaded`)

      loadedScripts[src] = true
      resolve()
    }

    document.head.appendChild(script)
  })
}

const loadScriptsSerially = async (srcs, async) => {
  for (let i = 0; i < srcs.length; i++) {
    await loadScript(srcs[i], async) // eslint-disable-line
  }
}

type Opts = {
  async?: boolean // load scripts asynchronously (don't block other js execution)
  serial?: boolean // load scripts sequentially (load every other script only when current be finished)
}

const useScriptsLoader = (srcs: string[], opts?: Opts) => {
  const { async, serial } = opts || {}

  const isLoaded = srcs.every((src) => Boolean(loadedScripts[src]))

  const [ state, setState ] = useState({ isFetching: !isLoaded, isLoaded, error: null })

  useEffect(() => {
    if (isLoaded) {
      return
    }

    let promise

    if (serial) {
      promise = loadScriptsSerially(srcs, async)
    }
    else {
      promise = Promise.all(srcs.map((src) => loadScript(src, async)))
    }

    promise
      .then(() => {
        setState({ isFetching: false, isLoaded: true, error: null })
      })
      .catch((err) => {
        setState({ isFetching: false, isLoaded: false, error: err })
      })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}


export default useScriptsLoader
